import ProxyBase from '../../../../../../../core/proxies/ProxyBase'

class HeaderCompanyAnalysisProxy extends ProxyBase {
  getHeaderCompanyAnalysis(params) {
    return this.get('CompanyProfile/CompanyHeader', params, undefined, true)
  }
  getScoreRangesCreditRisk(params) {
    return this.get('Score/ScoreRangesCreditRisk', params)
  }
  getScoreRangesPerformance(params) {
    return this.get('Score/ScoreRangesPerformance', params)
  }
}

export default new HeaderCompanyAnalysisProxy()
